module.exports = __webpack_public_path__ + "media/images/top-page_hero-image@2x-61db1da810fcfef4ca8c2daff1b7bd45.jpg";